/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_Analytics_DescriptionInputs */

const da_consent_analytics_description = /** @type {(inputs: Consent_Analytics_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog registrerer, hvilke funktioner du bruger, og tekniske fejl, knyttet til din konto, og gør det muligt at sende feedback om appen. Uden dit samtykke gemmer PostHog intet i din browser og knytter intet til din konto, og feedbackknappen er skjult.`)
};

/** @type {(inputs: Consent_Analytics_DescriptionInputs) => LocalizedString} */
const en_consent_analytics_description = da_consent_analytics_description;

/**

* @param {Consent_Analytics_DescriptionInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_analytics_description = /** @type {((inputs?: Consent_Analytics_DescriptionInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_Analytics_DescriptionInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_analytics_description(inputs)
	return /** @type {LocalizedString} */ ("PostHog registrerer, hvilke funktioner du bruger, og tekniske fejl, knyttet til din konto, og gør det muligt at sende feedback om appen. Uden dit samtykke gemmer PostHog intet i din browser og knytter intet til din konto, og feedbackknappen er skjult.")
});